"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreLink = _interopRequireDefault(require("@vfuk/core-link"));

var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));

var Styled = _interopRequireWildcard(require("./styles/SideNavigationSecondaryList.style"));

var _TopNavigationContext = _interopRequireDefault(require("../../../../context/TopNavigationContext"));

var _simpleClickHandler = _interopRequireDefault(require("../../../../helpers/simpleClickHandler"));

var _getDataAttributes = _interopRequireDefault(require("../../../../helpers/getDataAttributes"));

var _constants = require("../../../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SideNavigationSecondaryList = function SideNavigationSecondaryList() {
  var _ref = (0, _react.useContext)(_TopNavigationContext["default"]),
      topNav = _ref.topNav,
      interactionHandler = _ref.interactionHandler,
      dataAttributePrefix = _ref.dataAttributePrefix;

  if (!topNav) return null;
  var leftLinks = topNav.leftLinks,
      rightLinks = topNav.rightLinks;
  return /*#__PURE__*/_react["default"].createElement(Styled.SideNavigationSecondaryList, null, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, leftLinks === null || leftLinks === void 0 ? void 0 : leftLinks.map(function (link) {
    var _link$links;

    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: link.id
    }, /*#__PURE__*/_react["default"].createElement(_coreListItem["default"], null, /*#__PURE__*/_react["default"].createElement(_coreLink["default"], {
      text: link.text,
      to: link.to,
      href: link.url,
      onClick: function onClick(event) {
        return (0, _simpleClickHandler["default"])(event, interactionHandler, dataAttributePrefix, link);
      },
      htmlAttributes: {
        dataAttributes: {
          'data-selector': (0, _getDataAttributes["default"])("".concat(_constants.DataKeys.SecondarySideNavigation, "-").concat(link.id), dataAttributePrefix)
        }
      }
    })), link.active && link.links ? (_link$links = link.links) === null || _link$links === void 0 ? void 0 : _link$links.map(function (subLink) {
      return /*#__PURE__*/_react["default"].createElement(_coreListItem["default"], {
        key: subLink.id
      }, /*#__PURE__*/_react["default"].createElement(_coreLink["default"], {
        text: subLink.text,
        to: subLink.to,
        href: subLink.url,
        onClick: function onClick(event) {
          return (0, _simpleClickHandler["default"])(event, interactionHandler, dataAttributePrefix, subLink);
        },
        htmlAttributes: {
          dataAttributes: {
            'data-selector': (0, _getDataAttributes["default"])("".concat(_constants.DataKeys.SecondarySideNavigation, "-").concat(link.id), dataAttributePrefix)
          }
        }
      }));
    }) : null);
  }), rightLinks === null || rightLinks === void 0 ? void 0 : rightLinks.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(_coreListItem["default"], {
      key: link.id
    }, /*#__PURE__*/_react["default"].createElement(_coreLink["default"], {
      text: link.text,
      to: link.to,
      href: link.url,
      onClick: function onClick(event) {
        return (0, _simpleClickHandler["default"])(event, interactionHandler, dataAttributePrefix, link);
      },
      htmlAttributes: {
        dataAttributes: {
          'data-selector': (0, _getDataAttributes["default"])("".concat(_constants.DataKeys.SecondarySideNavigation, "-").concat(link.id), dataAttributePrefix)
        }
      }
    }));
  })));
};

SideNavigationSecondaryList.displayName = "SideNavigationSecondaryList";
var _default = SideNavigationSecondaryList;
exports["default"] = _default;
//# sourceMappingURL=SideNavigationSecondaryList.js.map